import vendors from '@/configurations/general/vendors'
import Query from '@/classes/queries/Query'

export const useVendors = () => {
  const embed_video_vendors = vendors.filter(vendor => vendor.category === 'video')

  const getVendor = name => vendors.find(vendor => vendor.name === name)

  const isEmbedVideoUrl = url => embed_video_vendors.some(({ regex }) => url.match(regex))

  const getVendorByUrl = url => vendors.find(vendor => vendor.regex?.test(url))

  const getVendorUrl = ({ src, params = {} }) => {
    const vendor = getVendorByUrl(src)

    if (!vendor) return ''

    const query = new Query({ query: { ...vendor?.params, ...params } }).to_string
    const url = src.replace(vendor.regex, vendor.url)

    return url + query.replace('?', url.includes('?') ? '&' : '?')
  }

  const getVendorRegexExpression = ({ name, flags }) => {
    const vendor = getVendor(name)

    return vendor ? new RegExp(vendor.regex.source, flags || vendor.regex.flags) : new RegExp('')
  }

  return {
    vendors,
    isEmbedVideoUrl,
    getVendor,
    getVendorByUrl,
    getVendorUrl,
    getVendorRegexExpression
  }
}